import React from 'react';
import { Heading, Text } from '@/Components/ui/typography';
import { Stack } from '@/Components/ui/layout';

function Biography({profileData}) {
  return (
    <div className="flex max-w-full w-[536px] flex-col">
      <Heading level="h2" size="lg" className="font-medium text-slate-900 leading-none m-0">
        BIOGRAPHY
      </Heading>
      <Text size="base" className="mt-6 w-full text-slate-600 font-normal leading-6">
        {profileData.data.bio}
      </Text>
    </div>
  );
}

export default Biography;